export default "__VITE_ASSET__CkhI5M8S__"